<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.Params.Key"
          style="width: 15%"
          placeholder="关键字"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-dropdown
          split-button
          @click="onLoad"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li
        style="display: flex; align-items: center"
        v-if="
          $store.state.loginUser?.IsAdmin ||
          $store.state.loginUser?.Qxs?.includes('B_ZuHeChanPin_List_添加')
        "
      >
        <el-button
          type="primary"
          icon="Plus"
          link
          @click="
            delete state.selectId;
            state.showCompile = true;
          "
        >
          添加
        </el-button>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="IsQy"
          sortable="IsQy"
          label="状态"
          align="center"
          width="80"
        >
          <template #default="scope">
            <text :style="{ color: scope.row.IsQy ? '#080' : '#f00' }">
              {{ scope.row.IsQy ? "上架" : "下架" }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="Mc"
          sortable="Mc"
          label="组合名称"
          :show-overflow-tooltip="true"
          min-width="150"
        />
        <el-table-column label="封面图" width="80" align="center">
          <template #default="scope">
            <el-image
              v-if="scope.row.Fm"
              :src="scope.row.Fm"
              style="width: 50px; height: 50px; border-radius: 4px"
              fit="cover"
              :preview-src-list="[scope.row.Fm]"
            />
            <text v-else style="color: #ccc">无</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="Yhj"
          sortable="Yhj"
          label="价格"
          width="120"
          align="center"
        >
          <template #default="scope">
            <text v-if="scope.row.Yhj > 0">
              ¥{{ scope.row.Yhj }}{{ scope.row.TcCount > 1 ? '起' : '' }}
            </text>
            <text v-else style="color: #ccc">-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="IsYuyue"
          label="预约"
          width="80"
          align="center"
        >
          <template #default="scope">
            <text v-if="scope.row.IsYuyue" style="color: #1779de">
              需预约({{ scope.row.YuyueTianShu }}天)
            </text>
            <text v-else style="color: #999">否</text>
          </template>
        </el-table-column>
        <el-table-column label="有效期" width="200" align="center">
          <template #default="scope">
            <text v-if="scope.row.YxKssj && scope.row.YxJzsj">
              {{ String(scope.row.YxKssj).substring(0, 10) }} ~ {{ String(scope.row.YxJzsj).substring(0, 10) }}
            </text>
            <text v-else-if="scope.row.YxKssj || scope.row.YxJzsj">
              {{ String(scope.row.YxKssj || scope.row.YxJzsj).substring(0, 10) }}
            </text>
            <text v-else style="color: #ccc">-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="创建信息"
          width="160"
          :formatter="(row) => $tab_GroupFormat(row.CjrXm, row.Cjsj)"
        />
        <el-table-column
          label="操作"
          width="180"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Edit"
              link
              @click="
                $store.commit('openMenu', {
                  path: 'ZuHeChanPinDetail',
                  title: '编辑组合产品',
                  data: { id: row.Id },
                  refresh: true,
                })
              "
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_ZuHeChanPin_List_编辑')
              "
              >编辑
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row.Id)"
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_ZuHeChanPin_List_删除')
              "
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.PageIndex"
      @onLoad="
        (pageIndex) => {
          state.params.PageIndex = pageIndex;
          onLoad();
        }
      "
    >
    </c_page>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showCompile"
        :title="(state.selectId ? '修改' : '添加') + '组合产品'"
        @close="state.showCompile = false"
      >
        <c_ZuHeChanPinCompile
          @close="
            state.showCompile = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_ZuHeChanPinCompile>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { zuhechanpin_list, zuhechanpin_delete } from "@/http/api";
import { confirm_func } from "@/util/tFormat";

class InitFormData {
  params = {
    PageSize: 20,
    PageIndex: 1,
    Params: {},
    Order: "Cjsj",
    Asc: false,
  };
  showCompile = false;
  selectId = null;
}

export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      zuhechanpin_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = (column) => {
      if (column.order) {
        state.params.Order = column.prop;
        state.params.Asc = column.order === "ascending";
      } else {
        state.params.Order = "Cjsj";
        state.params.Asc = false;
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(zuhechanpin_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
    };
  },
};
</script>
<style scoped></style>
